import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ChatBubbleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"chat_bubble"}/>
}
